<template>
  <KTCard
    data-cy="notifications-page"
    :title="$t('page.notification.title')"
  >
    <b-form novalidate>
      <b-form-checkbox-group
        v-model="form.selectedNotifications"
        :options="notificationOptions"
        data-cy="notifications"
        stacked
        switches
        size="lg"
      />
    </b-form>

    <template v-slot:footer>
      <div class="mr-auto">
        <ButtonElement
          data-cy="submit-btn"
          variant="primary"
          text="save"
          class="mr-3"
          @click="onClickSubmit"
        />
      </div>
    </template>
  </KTCard>
</template>

<script>
import KTCard from '@/components/card/KTCard';
import ButtonElement from '@/components/ButtonElement';
import { mapGetters } from 'vuex';
import apolloMixin from '@/mixins/apollo.mixin';
import { updateNotifications } from './gql/mutations';

export default {
  name: 'Notifications',
  components: {
    KTCard,
    ButtonElement,
  },

  mixins: [apolloMixin],

  data() {
    return {
      notifications: [],
      form: {
        selectedNotifications: [],
      },
    };
  },

  mounted() {
    this.$setBreadcrumbs([], true);
  },

  created() {
    this.form.selectedNotifications = Object.keys(
      this.userNotifications,
    ).filter((key) => this.userNotifications[key] === 1);
  },

  computed: {
    ...mapGetters(['userNotifications']),

    notificationOptions() {
      return Object.keys(this.userNotifications).map((key) => ({
        value: key,
        text: this.$t(`page.notification.notifications.${key}`),
      }));
    },
  },

  methods: {
    async onClickSubmit() {
      const notifications = Object.keys(this.userNotifications).map((key) => ({
        key,
        enabled: this.form.selectedNotifications.includes(key),
      }));

      await this.$post(updateNotifications, {
        notifications,
      });
    },
  },
};
</script>
